<!--&================== TITLE LIBRARY ==================&-->
<div class="title-components">
  <h1>Usuarios</h1>
</div>

<div class="Options-Menu">
  <!---================= CONTAINER SELECT TYPE Finance =================--->
  <div *ngIf="isList" class="Card-Option container-global-components">
    <div class="Icon-Left">
      <button (click)="Search_Validate()" class="Local-Icon-Card button-square">
        <i class="fa-solid fa-magnifying-glass"></i>
      </button>
    </div>

    <div class="Container-Card Search-file">
      <div class="Input-Option Search-file">
        <div class="search inputText">
          <input type="text" placeholder="Buscar usuario (Mínimo 2 caracteres)" [(ngModel)]="Input_Search"
            (keyup)="Search_User()" (keyup)="Search_Enter($event)" />
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isList" class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-gear"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Actualizar información</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <!---================= CONTAINER RELOAD PAGE =================--->
        <div class="Container-Buttons">
          <div (click)="Reload_Page()" class="Btn-Option button-square">
            <span class="Tool-Tip">Recargar pagina</span>
            <i class="fa-solid fa-rotate-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!---================= CONTAINER RELOAD PAGE =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-users"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Opciones de usuario</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons">
          <div (click)="Toggle_Modal_Add_User(true)" class="Btn-Option Add button-square">
            <span class="Tool-Tip">Agregar nuevo usuario al sistema</span>
            <i class="fa-solid fa-plus"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-hashtag"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Total De Usuarios</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons">
          <div class="Generate-Report-Level">
            {{ All_Users.length }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!---================= CONTAINER RELOAD PAGE =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-list"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Registros en forma de {{ this.isList ? "carta" : "lista" }}</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <div class="Container-Buttons Switch">
          <div class="Input-Switch">
            <input [(ngModel)]="isList" type="checkbox" name="" id="Inheritance_Check" />
            <label for="Inheritance_Check"></label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="All_Users_Copy.length > 0 && LoadPage && isList" class="Card">
  <div class="Card__Container">
    <div *ngFor="let User of All_Users_Copy; let i = index" class="Card__Container--Item">
      <div class="Card__Container--Item--Check {{ ContainMail(User.email) }}">
        <i class="fa-solid fa-check"></i>
      </div>

      <button class="Card__Container--Item--Header" (click)="Toggle_Modal_Option(i)">
        <i class="fa-solid fa-ellipsis-vertical"></i>

        <div class="Card__Container--Item--Header--ContainerOption" id="Card_Option{{ i }}">
          <button [routerLink]="['/Dashboard/Admin/RelationU/', User.ID]"
            class="Card__Container--Item--Header--ContainerOption--Option button-square Info">
            <i class="fa-solid fa-shield"></i>
          </button>
          <button (click)="Update_Data_User(User)"
            class="Card__Container--Item--Header--ContainerOption--Option button-square Edit">
            <i class="fa-solid fa-pencil"></i>
          </button>
          <button (click)="Delete_User(User)"
            class="Card__Container--Item--Header--ContainerOption--Option button-square Remove">
            <i class="fa-regular fa-trash-can"></i>
          </button>
        </div>
      </button>

      <div class="Card__Container--Item--Body">
        <div class="Card__Container--Item--Body--Img">
          <span class="Card__Container--Item--Body--Img--Name">{{
            Format_Initials(User.Nombre)
            }}</span>
          <span class="Card__Container--Item--Body--Img--Point"></span>
        </div>
        <div class="Card__Container--Item--Body--Name">
          {{ User.Nombre }}
        </div>
        <div class="Card__Container--Item--Body--Description">PDMS</div>

        <div class="Card__Container--Item--Body--Info">
          <div class="Card__Container--Item--Body--Info--Section">
            <div class="Card__Container--Item--Body--Info--Section--Icon">
              <i class="fa-regular fa-envelope"></i>
            </div>
            <div class="Card__Container--Item--Body--Info--Section--InfoS">
              <div class="Card__Container--Item--Body--Info--Section--InfoS--Title">
                Correo electronico
              </div>
              <div class="Card__Container--Item--Body--Info--Section--InfoS--Description">
                {{ Format_Mail(User.email) }}
              </div>
            </div>
          </div>
        </div>

        <div class="Card__Container--Item--Body--Info">
          <div class="Card__Container--Item--Body--Info--Section">
            <div class="Card__Container--Item--Body--Info--Section--Icon">
              <i class="fa-regular fa-calendar"></i>
            </div>
            <div class="Card__Container--Item--Body--Info--Section--InfoS">
              <div class="Card__Container--Item--Body--Info--Section--InfoS--Title">
                Fecha de modificacion
              </div>
              <div class="Card__Container--Item--Body--Info--Section--InfoS--Description">
                {{ Date_Format(User.Fecha_Modificacion) }}
              </div>
            </div>
          </div>
        </div>

        <div class="Card__Container--Item--Body--Info">
          <div class="Card__Container--Item--Body--Info--Section">
            <div class="Card__Container--Item--Body--Info--Section--Icon">
              <i class="fa-solid fa-fingerprint"></i>
            </div>
            <div class="Card__Container--Item--Body--Info--Section--InfoS">
              <div class="Card__Container--Item--Body--Info--Section--InfoS--Title">
                Login name
              </div>
              <div class="Card__Container--Item--Body--Info--Section--InfoS--Description">
                {{ Format_LoginName(User.LoginName) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="
      Input_Search.length < 2 ? All_Users.length : All_Users_Copy_Search.length
    " [rowsPerPageOptions]="[6, 12, 15, 20, 30]"></p-paginator>
</div>

<div *ngIf="All_Users_Copy.length > 0 && LoadPage && !isList" class="container-global-components ConFLFIN">
  <div class="Table-Lib Table-container-Global">
    <p-table #dt [value]="All_Users" [(selection)]="All_Users_Copy_Table" dataKey="id" [rowHover]="true" [rows]="10"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 15, 25, 50]" [paginator]="true"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
      [globalFilterFields]="['Nombre', 'Descripcion']">
      <!--&================= SEARCH AND ALL Groups =================&-->
      <ng-template pTemplate="caption">
        <div class="SectionCreateTotal Section-Groups Table_NG">
          <div class="left-CT">
            <div class="search inputText">
              <i class="fa-solid fa-magnifying-glass"></i><input [(ngModel)]="Input_Search_Table" type="text"
                (input)="dt.filterGlobal(Input_Search_Table, 'contains')" placeholder="Buscar usuario" />
            </div>
          </div>
          <div class="right-CT">
            <div class="AllFiles">
              Total de usuarios: <b>{{ All_Users.length }}</b>
              <i class="fa-solid fa-users"></i>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <ng-container *ngFor="let Header of Headers_Users">
            <ng-container *ngIf="Header.Key_Header === 'NAMEU'">
              <th pSortableColumn="Nombre" class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Nombre"></p-sortIcon>
                    <p-columnFilter type="text" field="Nombre" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'EMAIL'">
              <th pSortableColumn="email" class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="email"></p-sortIcon>
                    <p-columnFilter type="text" field="email" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'LOGIN'">
              <th pSortableColumn="LoginName" class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="LoginName"></p-sortIcon>
                    <p-columnFilter type="text" field="LoginName" display="menu" class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DATEM'">
              <th pSortableColumn="Fecha_Modificacion" class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                  <span class="Icon-Th">
                    <p-sortIcon field="Fecha_Modificacion"></p-sortIcon>
                    <p-columnFilter type="date" field="Fecha_Modificacion" display="menu"
                      class="ml-auto"></p-columnFilter>
                  </span>
                </div>
              </th>
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'OPTIO'">
              <th class="{{ Header.Key_Header }}">
                <div class="Grid-Th">
                  <span>{{ Header.Name }}</span>
                </div>
              </th>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-User>
        <tr>
          <td *ngFor="let Header of Headers_Users" class="{{ Header.Key_Header }}">
            <ng-container *ngIf="Header.Key_Header === 'NAMEU'">{{ User.Nombre }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'EMAIL'">{{ Format_Mail(User.email) }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'LOGIN'">{{ User.LoginName }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'DATEM'">{{ Date_Format(User.Fecha_Modificacion) }}
            </ng-container>

            <ng-container *ngIf="Header.Key_Header === 'OPTIO'">
              <button (click)="Update_Data_User(User)" class="Btn-Option button-square Edit">
                <i class="fa-solid fa-pencil"></i>
              </button>
              <button (click)="Delete_User(User)" class="Btn-Option button-square Remove">
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td *ngIf="All_Users.length > 0" colspan="8">Sin coincidencias.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<div *ngIf="All_Users_Copy.length === 0 && LoadPage && Input_Search.length > 0"
  class="container-global-components ConFLFIN">
  <div class="Not-User">
    <div class="Img-Not">
      <img src="./assets/Global/Ilustrations/No-Find.png" alt="" />
    </div>
    <div class="Text-Not-User">
      No existe ningún usuario con el nombre {{ Input_Search }}
    </div>
  </div>
</div>

<div *ngIf="All_Users_Copy.length === 0 && LoadPage && Input_Search.length === 0"
  class="container-global-components ConFLFIN">
  <div class="Not-User">
    <div class="Img-Not">
      <img src="./assets/Global/Ilustrations/Not-User.png" alt="" />
    </div>
    <div class="Text-Not-User">¡Aún no existen usuarios en el sistema!</div>
  </div>
</div>

<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR UPDATE DATA USER =====================--->
<section class="Modal-Global" id="Modal_Update_User">
  <div class="wrapper">
    <div class="Pro-popup-UDU popup">
      <div class="Pro-inside-UDU popup-inside">
        <div class="Pro-backgrounds-UDU backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form [formGroup]="Form_Update_User" (ngSubmit)="Saved_User()">
        <div class="Pro-content-UDU content">
          <button (click)="Toggle_Modal_Update_User(false)" type="button" id="Btn-Close-Add-Top" class="Btn-Close">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <div class="Content-Top">
            <h2>Editar usuario</h2>
          </div>

          <div class="Content-body">
            <div class="Content-grid-2">
              <div class="Text-icon">Nombre</div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-signature"></i><input id="Idinput_Name_Update" type="text" formControlName="Name"
                  placeholder="Nombre de usuario…" />
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">Correo electrónico</div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-regular fa-envelope"></i><input id="Idinput_Mail_Update" type="text" formControlName="Mail"
                  placeholder="Correo electrónico…" />
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">LoginName</div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-fingerprint"></i><input id="Idinput_LoginName_Update" type="text"
                  formControlName="LoginName" placeholder="LoginName…" />
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">Contraseña</div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-lock"></i>
                <input id="Idinput_Password_Update" type="password" formControlName="Password"
                  placeholder="Nueva contraseña (opcional, mínimo 8 caracteres)…" />
              </div>
            </div>

            <div class="Content-Bottom">
              <button type="submit" class="Btn-LSave-Form3 btn-icon-text">
                <i class="fa-solid fa-check-double"></i><span class="text">Guardar cambios</span>
              </button>
              <button (click)="Toggle_Modal_Update_User(false)" type="button" class="Btn-LCancel-Form Btn-Close-Modal">
                <span>Cerrar</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL FOR ADD USER =====================--->
<section class="Modal-Global" id="Modal_Add_User">
  <div class="wrapper">
    <div class="Pro-popup-RU popup">
      <div class="Pro-inside-RU popup-inside">
        <div class="Pro-backgrounds-RU backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form>
        <div class="Pro-content-RU content">
          <button (click)="Toggle_Modal_Add_User(false)" type="button" id="Btn-Close-Add-Top" class="Btn-Close"><i
              class="fa-solid fa-xmark"></i></button>
          <div class="Content-Top">
            <h2>Crear Nuevo Usuario</h2>
          </div>

          <div class="BodyAddUser">
            <div class="SectionForm">
              <div class="SectionForm__Left">
                <img src="./assets/Global/Icon_user.png" alt="User Icon" height="120px">
              </div>
              <div class="SectionForm__Right">
                <form [formGroup]="formCreateUser" class="SectionForm__Right--form"
                  style="box-shadow: none !important;">
                  <input type="hidden" formControlName="Idioma" />

                  <div class="Container-input Input-Text-Form">
                    <i class="fa-solid fa-user"></i>
                    <input id="Idinput_Name_Create" type="text" formControlName="Nombre" placeholder="Nombre Real" />
                  </div>

                  <div class="Container-input Input-Text-Form">
                    <i class="fa-solid fa-fingerprint"></i>
                    <input id="Idinput_LoginName_Create" type="text" formControlName="LoginName"
                      placeholder="Login Name" />
                  </div>

                  <div class="Container-input Input-Text-Form">
                    <i class="fa-regular fa-envelope"></i>
                    <input id="Idinput_Mail_Create" type="email" formControlName="email" placeholder="Correo" />
                  </div>

                  <div class="Container-input Input-Text-Form">
                    <i class="fa-solid fa-key"></i>
                    <input id="Idinput_Password_Create" type="password" formControlName="password"
                      placeholder="Contraseña" />
                  </div>

                  <div class="Container-input Input-Text-Form">
                    <i class="fa-solid fa-key"></i>
                    <input id="Idinput_Password_Confirm_Create" type="password" formControlName="passwordConfirm"
                      placeholder="Confirmar Contraseña" />
                  </div>

                </form>
              </div>
            </div>
          </div>
          <br><br><br><br><br>
          <div class="Content-Bottom" style="margin-top: -12px;">
            <button class="Btn-LSave-Form Btn-Save-Modal" (click)="addUser()">
              <i class="icon-send material-icons" id="Send-Icon">send</i>
              <i class="icon-check material-icons" id="Check-Icon">check</i>
              <span class="Btn-Save-Modal-text" id="Text-Btn">Guardar Usuario Nuevo</span>
            </button>
            <button type="button" id="Btn-Close-Add-Bottom" (click)="Toggle_Modal_Add_User(false)"
              class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </button>
          </div>

        </div>

      </form>

    </div>
  </div>
</section>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>